import { TextField } from "@pankod/refine-mui";
import { UseModalFormReturnType } from "@pankod/refine-react-hook-form";

import { Modal } from "../modal";

export const Create: React.FC<UseModalFormReturnType> = ({
    register,
    formState: { errors },
    refineCore: { onFinish, formLoading },
    handleSubmit,
    modal: { visible, close },
    saveButtonProps,
}) => {
    return (
        <Modal
            isOpen={visible}
            onClose={close}
            title="Create a List"
            submitText={formLoading ? "Loading" : "Create"}
            onSubmitClick={saveButtonProps.onClick}
            submitDisabled={saveButtonProps.disabled}
        >
            <form className="form" onSubmit={handleSubmit(onFinish)}>
                <TextField
                    label="List Name"
                    placeholder="Name"
                    margin="normal"
                    fullWidth
                    {...register("name", {
                        required: "This field is required",
                    })}
                />
            </form>
        </Modal>
    );
};
